import { z } from "zod";
import { PushPlatformSchema } from "../enums";

/** `POST /api/push/register`. */
export const RegisterPushSchema = z.object({
  expoToken: z.string().min(1),
  platform: PushPlatformSchema,
});
export type RegisterPush = z.infer<typeof RegisterPushSchema>;

/** `DELETE /api/push/register`. */
export const UnregisterPushSchema = z.object({
  expoToken: z.string().min(1),
});
export type UnregisterPush = z.infer<typeof UnregisterPushSchema>;
